<template>
    <div class="setting-content--section">
        <b-form @submit="onSubmit">
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Logo')" label-for="input-1">
                <VueDropzone :preloaded_file="imageSrc" :upload_url="Urls['company_profile_detail'](form.id)" image_field_name="logo" :delete_url="Urls['company_profile_delete_logo'](form.id)"></VueDropzone>
            </b-form-group>
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Name*')" label-for="input-1" :description="$gettext('Name of your company.')">
                <b-form-input id="input-1" v-model="form.name" required :placeholder="$gettext('Enter company name')" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Type of business entity')" label-for="input-2">
                <b-form-select id="input-2" v-model="form.legal_form" :options="entities" value-field="key" text-field="value" @change="onFormChange"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Sector')" label-for="input-3">
                <b-form-select id="input-3" v-model="form.sector" :options="sectors" value-field="key" text-field="value" @change="onFormChange">
                    <template #first>
                        <b-form-select-option :value="null" >---------</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Company Description')" label-for="input-4">
                <b-form-textarea id="input-4" v-model="form.description" :placeholder="$gettext('Enter a description here...')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>
            <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Address')" label-for="input-5">
                <b-form-input id="input-5" v-model="form.address" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Postal Code')" label-for="input-6">
                <b-form-input id="input-6" v-model="form.postal_code" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('City')" label-for="input-7">
                <b-form-input id="input-7" v-model="form.city" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Country') + '*'" label-for="input-8">
                <b-form-select id="input-8" v-model="form.country" :options="countries" @change="onFormChange" :disabled="true" required></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Phone number')" label-for="input-9">
                <b-form-input id="input-9" v-model="form.phone_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-10" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-10" class="checkbox-bg-color" v-model="form.phone_number_show_on_invoice" @change="onFormChange" switch><span v-translate>Show phone number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-11" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-11" :description="$gettext('Invoices will be sent from this e-mail address.')">
                <b-form-input id="input-11" v-model="form.email" type="email" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-12" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('KvK number')" label-for="input-12" :description="$gettext('Chamber of Commerce registration number.')">
                <b-form-input id="input-12" v-model="form.kvk" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-13" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('VAT identification number')" label-for="input-13">
                <b-form-input id="input-13" v-model="form.btw" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-14" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-14" class="checkbox-bg-color" v-model="form.btw_show_on_invoice" @change="onFormChange" switch><span v-translate>Show VAT identification number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-15" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank name')" label-for="input-15">
                <b-form-input id="input-15" v-model="form.bank_name" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-16" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('Bank account number')" label-for="input-16">
                <b-form-input id="input-16" v-model="form.bank_account_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-17" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('BIC/Swift')" label-for="input-17">
                <b-form-input id="input-17" v-model="form.companysettings.swift_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-18" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-18" class="checkbox-bg-color" v-model="form.companysettings.show_swift_on_invoice" @change="onFormChange" switch><span v-translate>Show BIC/Swift on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-alert class="float-alert-top" :show="showDismissibleCountdown" variant="success" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
              Settings successfully updated!
            </b-alert>
            <b-form-group id="input-group-19" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-19">
                <GekkoButton 
                    :href="Urls['accounts_delete_company'](form.id)"
                    :text="$gettext('Delete company')" 
                    icon="fa-solid fa-trash-can"
                    type="submit"
                    variant="link"
                    class="mr-2 text-danger"
                />
                <GekkoButton 
                    :text="$gettext('Save Settings')" 
                    icon="fa-solid fa-floppy-disk"
                    type="submit"
                />
            </b-form-group>

        </b-form>
    </div>
</template>

<script>
//todo: add this to the api
//if company.legal_form:
//      TrackEvents().set_people(request.user.email, {'legal_form': company.legal_form})


// @ is an alias to /src
import CompanyService from "@/store/services/company.service.js";
import CompanySettingService from "@/store/services/companysetting.service.js";
import VueDropzone from "@/components/VueDropzone";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CompanySettings",
    components: {
        VueDropzone, GekkoButton
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            showDismissibleCountdown: 0,
            pageSettings: {
                title: this.$gettext("Change your company details"),
                showCompanyPicker: true
            },
            formChanged: false,
            form: {
                id: '',
                address: '',
                bank_account_number: '',
                bank_name: '',
                btw: '',
                btw_show_on_invoice: false,
                city: '',
                country: 'NL',
                description: '',
                email: '',
                kvk: '',
                legal_form: '',
                logo: null,
                name: '',
                phone_number: '',
                phone_number_show_on_invoice: false,
                postal_code: '',
                sector: '',
                companysettings: {
                    id: '',
                    company: '',
                    show_swift_on_invoice: false,
                    swift_number: ''
                }
            },
            entities: [],
            sectors: [],
            countries: [],
            imageSrc: '',
        }
    },
    created(){
        var vm = this;
        CompanyService.getCurrent().then(function(response){
            var data = response.data;
            vm.form = {
                id: data['id'],
                address: data['address'],
                bank_account_number: data['bank_account_number'],
                bank_name: data['bank_name'],
                btw: data['btw'],
                btw_show_on_invoice: data['btw_show_on_invoice'],
                city: data['city'],
                country: data['country'],
                description: data['description'],
                email: data['email'],
                kvk: data['kvk'],
                legal_form: data['legal_form'],
                name: data['name'],
                phone_number: data['phone_number'],
                phone_number_show_on_invoice: data['phone_number_show_on_invoice'],
                postal_code: data['postal_code'],
                sector: data['sector'],
                companysettings: {
                    id: data.companysettings['id'],
                    company: data.companysettings['company'],
                    show_swift_on_invoice: data.companysettings['show_swift_on_invoice'],
                    swift_number: data.companysettings['swift_number']
                }
            };
            if(response.data.logo){
                vm.imageSrc = response.data.logo;
            }
        });
        CompanyService.getBusinessEntities().then(function(response){
            vm.entities = response.data[vm.form.country.toLowerCase()];
        });
        CompanyService.getSectors().then(function(response){
            vm.sectors = response.data;
        });
        CompanyService.getCountries().then(function(response){
            vm.countries = response.data;
        });
    },
    methods: {
        onSubmit(evt) {
            let vm = this;
            evt.preventDefault();
            //create or edit
            if(this.form.logo === null){
                delete(this.form.logo);
            }
            if(this.form.id){
                CompanyService.update(this.form).then(function(){
                 vm.showDismissibleCountdown = 2;
                 vm.formChanged = false;
                });
                CompanySettingService.update(this.form.companysettings);
            }
        },
        onFormChange(){
            this.formChanged = true;
        }
    },
    beforeRouteLeave (to, from , next) {
      var answer = true;
      if(this.formChanged){
        answer = window.confirm(this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'))
      }
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
};
</script>
<style >
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}

.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}
</style>
